import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { BookmarkCheck, CornerLeftUp } from "lucide-react";
import { useEffect } from "react";
import { createPortal } from "react-dom";

const VISIBLE_MS = 7000;

/**
 * Объяснение прыжка к месту остановки. История открывается не с начала, и без
 * подписи это читается как сбой: «где пролог?». Плашка живёт несколько секунд,
 * уходит по первой прокрутке и даёт вернуться к началу одним нажатием.
 */
export function ResumeNotice({ percent, onDismiss, night = false }: { percent: number | null; onDismiss: () => void; night?: boolean }) {
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    if (percent === null) return;
    const timer = window.setTimeout(onDismiss, VISIBLE_MS);
    // Первая же прокрутка означает, что читатель сориентировался сам.
    let ignoreFirst = true;
    const onScroll = () => { if (ignoreFirst) { ignoreFirst = false; return; } onDismiss(); };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { window.clearTimeout(timer); window.removeEventListener("scroll", onScroll); };
  }, [percent, onDismiss]);

  return createPortal(<div className="resume-notice-position"><AnimatePresence>{percent !== null && <motion.div
    className={`resume-notice${night ? " resume-notice-night" : ""}`}
    role="status"
    initial={reduceMotion ? false : { opacity: 0, y: -14 }}
    animate={{ opacity: 1, y: 0 }}
    exit={reduceMotion ? { opacity: 0 } : { opacity: 0, y: -10 }}
    transition={{ duration: reduceMotion ? 0 : .24, ease: [0.22, 1, 0.36, 1] }}
  >
    <BookmarkCheck size={16} aria-hidden="true" />
    <span>Продолжаем с {Math.round(percent)}%</span>
    <button type="button" onClick={() => { window.scrollTo({ top: 0, behavior: reduceMotion ? "instant" : "smooth" }); onDismiss(); }}>
      <CornerLeftUp size={14} aria-hidden="true" /> В начало
    </button>
  </motion.div>}</AnimatePresence></div>, document.body);
}
